import React, { Component } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import Serverurl from './Apiurl';
import axios from 'axios';
import NotificationPopUp from './NotificationPopUp';
import "react-big-calendar/lib/css/react-big-calendar.css";
import notification from './images/notification-icon.png';
import { styled } from '@mui/material/styles';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
moment.locale("en-GB");
const localizer = momentLocalizer(moment);

export default class ReactBigCalendar extends Component 
{
constructor(props) 
	  {
			super();
			
			this.state = {eventsData:[],popuptype:"1",noid:0,celldate:'',edate:'',Yeararr:[],yearid:localStorage.getItem("MMCyearid")}
			  this.updateDonenewParent = this.updateDonenewParent;
	  }
	  		componentWillMount() { 
		
localStorage.setItem("pageactive",7)

this.YearBind();
}
 handleSelect=(date)=>{
	console.log(date);
 var month="",date1="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
	 
	 
	  if((date.getDate() )<10)
	 {
		date1="0"+ (date.getDate() )		 
	 }else{date1=(date.getDate())}
  
  date1=date.getFullYear()+"-"+month+"-"+date1
	 this.setState({ noid: 0 ,celldate:date1,edate:date});  
 /*   const title = window.prompt("New Event name");

     const updatedArray = [...this.state.eventsData];
	 updatedArray.title=title;
	 	 updatedArray.start=start;
		 updatedArray.end=end;
	 this.setState({eventsData:updatedArray});*/
	  setTimeout(() => this.refs.NotificationPopUp.handleClickOpen(),500);
 }
  handleNotification=(start,noid)=>{
	
	   this.setState({ noid: noid });  
	   setTimeout(() => this.refs.NotificationPopUp.handleClickOpen(),500);
  }
  updateDonenewParent = (text) => { this.NotificationAPIcall();  }
 componentDidMount() {
	 	document.title = "MM Coching Center - Notifications";
	
	if(localStorage.getItem("MMCuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
	 this.NotificationAPIcall();
	 
 }
 handleClickSearch=()=>{   
  
  this.NotificationAPIcall();	
} 
 myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val},()=>{
	  
	 
  });
 
}
NotificationAPIcall()
{let struserid="";
	if(localStorage.getItem("MMCrole")!=="1")
	 
		  { struserid=localStorage.getItem("MMCuserid");
		  }
axios.get(Serverurl+'ajaxnotifications.php?action=list&no_type=1&no_year_id='+this.state.yearid+'&userid='+struserid)
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({eventsData:resp.data});
			}else{
				this.setState({eventsData:[]});
			}
	   });
}
YearBind()
{
	axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=3')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Yeararr:resp.data,yearid:localStorage.getItem("MMCyearid")	
							}) 
			}
		
		
	   }) .then(data => {
        let yearFromApi = this.state.Yeararr.map(row => {
                          
          return {value: row.tc_id, display:row.tc_title}
        });
      
		
        this.setState({
          Yeararr: yearFromApi
        });
      })

}
customDayPropGetter = (date) => {

  let data = this.state.eventsData
  
   var month="",date1="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
	 
	 
	  if((date.getDate() )<10)
	 {
		date1="0"+ (date.getDate() )		 
	 }else{date1=(date.getDate())}
  
  date=date1+"/"+month+"/"+date.getFullYear()
   var obj = data.find((item, index) => {
	  
	   
	   
	   
	     if ((item.nodate === date && item.title !== "")  )
		 {
			 
			   return data[index]
		 }
   });
  
    if(obj !== undefined && obj.nodate === date &&  obj.title !== "")
	{
	 
        return { style: { backgroundColor: "#2588f5", Color:'#fff' } }
	}
    
        else {return { style: { backgroundColor: "#fff", Color:'#fff' } }}
   
	/*return {
	  style: {
		backgroundColor: '#fff', //this works
		color: '#ffffff' //but why doesn't this work?
	  }
	}*/
}

 eventStyleGetter=(event,start, end,isSelected)=>{

    console.log(event);
    var backgroundColor = '#2588f5' ;
    var style = {
        backgroundColor: backgroundColor,
        borderRadius: '0px',
        opacity: 0.8,
        color: '#fff',
        border: '0px',
        display: 'block',
		textalign:'Center',
    };
    return {
        style: style
    };
}
render() {
  return (
    <div className="pagebox-col"> 
	<div className="boxheading">
	  <div className="contntpad">
	  <h2><img src={notification} /> Notifications</h2>
	  </div> </div>
	
	<div className="contntpad">
	 <div className="searchmaster">


  
  <ul>
  
 <li>
		<p>Year</p>
	  <p>
	  <FormControl  fullWidth size="small" >
        
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.yearlabel, value: this.state.yearid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.yearid}
		  name="yearid"
		
		
        >
		{this.state.Yeararr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl> </p></li><li><p>&nbsp;</p><p>
 <Button variant="contained" onClick={this.handleClickSearch} className="frmPrimarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>	
 </p></li>
 </ul>
 </div>
		
		
	
<NotificationPopUp ref="NotificationPopUp" id={this.state.noid} celldate={this.state.celldate} edate={this.state.edate} notype={this.state.popuptype} updateDonenew={this.updateDonenewParent}/>

      <Calendar
        views={["month"]}
        selectable
        localizer={localizer}
        defaultDate={new Date()}
        defaultView="month"
		dayPropGetter={this.customDayPropGetter }
        events={this.state.eventsData}
        style={{ height: "140vh" }}
        onSelectEvent={(event) => this.handleNotification(event.start,event.id)}
		 eventPropGetter={(this.eventStyleGetter)}
        onSelectSlot={(event)=>this.handleSelect(event.start)}
      /> </div>
    </div>
  );
}
}
